import React, { useState } from 'react'
import {
  Paper,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  makeStyles,
  TextField
} from '@material-ui/core'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

function StructureList({ structures, itemClicked, currentStructures, translate }) {
  const classes = useStyles()
  const [activeItem, setActiveItem] = useState(null)
  const [filterText, setFilterText] = useState('')

  const itemClickHandler = structure => {
    let updatedActiveItem = null
    if (activeItem && activeItem.structure_id === structure.structure_id) {
      updatedActiveItem = null
    } else {
      updatedActiveItem = structure
    }
    setActiveItem(updatedActiveItem)

    itemClicked(structure)
  }

  const structureListItems = structures
    .filter(structure => structure.structure_name?.toLowerCase().includes(filterText.toLowerCase()))
    .map(structure => (
      <ListItem
        key={structure.structure_id}
        onClick={() => itemClickHandler(structure)}
        selected={
          !!currentStructures.includes(+structure.structure_id) ||
          activeItem?.structure_id === structure.structure_id
        }>
        <ListItemText>{structure.structure_name}</ListItemText>
      </ListItem>
    ))
  return (
    <Paper>
      <List dense className={classes.root}>
        <ListSubheader className={classes.listSection}>{translate('structure')}</ListSubheader>
        <ListItem>
          <TextField
            size={'small'}
            variant={'outlined'}
            fullWidth
            value={filterText}
            onChange={e => setFilterText(e.target.value)}
            label={translate('search')}
          />
        </ListItem>
        <ul className={classes.ul}>{structureListItems}</ul>
      </List>
    </Paper>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 400,
    paddingTop: 0
  },
  listSection: {
    backgroundColor: 'inherit'
  },
  ul: {
    backgroundColor: 'inherit',
    padding: 0
  }
}))

export default withTranslate(StructureList)
